import { Card, Checkbox, Col, Form, Row } from 'antd'
import { FormInstance } from 'antd/lib'

import { ConsultationType } from 'src/api/requests'
import { Text } from 'src/components'
import { usePersonBreadcrumb } from 'src/features/persons/hooks'
import { useLocales } from 'src/locales'

import { ConsultationFormAnamnesisSection } from './ConsultationFormAnamnesisSection'
import { ConsultationFormPhysicalExaminationSection } from './ConsultationFormPhysicalExaminationSection'

type Props = {
  form: FormInstance
}

export const ConsultationFormCard = ({ form }: Props) => {
  const { t } = useLocales()

  const { person } = usePersonBreadcrumb()

  const isPrimary =
    Form.useWatch(['generalInformation', 'consultationType'], form) ===
    ConsultationType.PRIMARY

  const hasPrimaryDiagnostic = !!Form.useWatch(
    ['assessment', 'finalDiagnosticIds'],
    form
  )?.length

  const cardTitle = isPrimary
    ? t('consultation_form.primary_title')
    : t('consultation_form.secondary_title')

  return (
    <Card title={cardTitle}>
      <Row gutter={[24, 24]}>
        <ConsultationFormAnamnesisSection isPrimary={isPrimary} form={form} />

        <ConsultationFormPhysicalExaminationSection
          isPrimary={isPrimary}
          form={form}
        />

        <Col span={24}>
          <Form.Item
            name="createPatientAccount"
            valuePropName="checked"
            extra={
              hasPrimaryDiagnostic ? undefined : (
                <Text color="red" size="sm">
                  {t('persons.create_patient_account_description')}
                </Text>
              )
            }
          >
            <Checkbox
              checked={!!person?.userProfileId}
              disabled={!!person?.userProfileId || !hasPrimaryDiagnostic}
            >
              {t('persons.allow_create_patient_account')}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  )
}
